import React from 'react';
import './TeamMember.css';
import TileSection from '../../Components/TileSection/TileSection';
import PhilPic from '../..//Images/Leadership/philipgazianoUpscaled.png';
import JohnPic from '../../Images/Leadership/John.jpg'
import FeliPic from '../../Images/Leadership/Feli.jpg'
import JasonPic from '../../Images/Leadership/Jason.jpg'
import DanPic from '../../Images/Leadership/David.png'
import Tracey from '../../Images/Leadership/Tracy.jpg'
import Leadership from './Leadership.json'
//import SimpleContent from '../../Components/TileSection/Content/SimpleContent';


const TeamSection: React.FC = () => {
  const leadership = Leadership as SimpleContent[];
  const images = [PhilPic, JohnPic, FeliPic, JasonPic, DanPic, Tracey];
  const teamMembers: TileSection[] = []

  leadership.forEach((item, index) => {
    const Bio: TileSection = {
      type: 1,
      isImgLeft: index >= 6 ? null : index % 2 === 0,
      imgSrc: index >= 6 ? null : images[index],
      content: item
    };
    teamMembers.push(Bio);
  });

  return (
    <main className='content'>
      {teamMembers.map((member, index) => (
        <div>
          {index === 6 && (
            <h1>Leadership and Technical Staff</h1>
          )}
          {index === 14 && (
            <h1>Academic & Governmental Advisors</h1>
          )}
          <TileSection type={member.type} isImgLeft={member.isImgLeft} imgSrc={member.imgSrc} content={member.content} />
          
        </div>
        
        
      ))}
    </main>
  );
};

export default TeamSection;